/**
 * Api Documentation
 * Api Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The RefreshRequest model module.
 * @module model/RefreshRequest
 * @version 1.0
 */
class RefreshRequest {
    /**
     * Constructs a new <code>RefreshRequest</code>.
     * @alias module:model/RefreshRequest
     */
    constructor() { 
        
        RefreshRequest.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>RefreshRequest</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/RefreshRequest} obj Optional instance to populate.
     * @return {module:model/RefreshRequest} The populated <code>RefreshRequest</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new RefreshRequest();

            if (data.hasOwnProperty('deviceId')) {
                obj['deviceId'] = ApiClient.convertToType(data['deviceId'], 'String');
            }
            if (data.hasOwnProperty('refreshToken')) {
                obj['refreshToken'] = ApiClient.convertToType(data['refreshToken'], 'String');
            }
        }
        return obj;
    }


}

/**
 * @member {String} deviceId
 */
RefreshRequest.prototype['deviceId'] = undefined;

/**
 * @member {String} refreshToken
 */
RefreshRequest.prototype['refreshToken'] = undefined;






export default RefreshRequest;

